/** Frontmatter for the "week1-sunday-monday-preview" article; the Body lives in week1-sunday-monday-preview.jsx. */
const meta = {
  slug: 'week1-sunday-monday-preview',
  title: 'Week 1 Fantasy Analysis: Every Sunday and Monday Game',
  category: 'Streaming',
  author: 'Andy Darkness',
  excerpt:
    'The full Week 1 slate broken down game by game. Start/sit calls for every relevant player across 14 Sunday and Monday matchups, D/ST rankings, IDP streamers, sleeper picks, and a pre-kickoff inactives checklist.',
  readMinutes: 25,
  date: '2026-09-12',
};

export default meta;
